export default {
  namespaced: true,
  state: {
    list: [],
    add: false,
    editPermission: false,
    editPermissionObj: {},
    delete: false,
    deleteObj: {},
  },
  getters: {
    list: state => state.list,
    add: state => state.add,
    editPermission: state => state.editPermission,
    editPermissionObj: state => state.editPermissionObj,
    delete: state => state.delete,
    deleteObj: state => state.deleteObj,
  },
  mutations: {
    listMutate(state, data) {
      state.list = data;
    },
    addMutate(state, data) {
      state.add = data;
    },
    editPermissionMutate(state, data) {
      state.editPermission = data;
    },
    editPermissionObjMutate(state, data) {
      state.editPermissionObj = data;
    },
    deleteMutate(state, data) {
      state.delete = data;
    },
    deleteObjMutate(state, data) {
      state.deleteObj = data;
    },
  },
  actions: {

    setList(context, data) {
      context.commit('listMutate', data);
    },
    setAdd(context, data) {
      context.commit('addMutate', data);
    },
    setEditPermission(context, data) {
      context.commit('editPermissionMutate', data);
    },
    setEditPermissionObj(context, data) {
      context.commit('editPermissionObjMutate', data);
    },
    setDelete(context, data) {
      context.commit('deleteMutate', data);
    },
    setDeleteObj(context, data) {
      context.commit('deleteObjMutate', data);
    },
  },
};
